import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPieChart1"><Path d="M21.7166 14.3737C21.9018 13.6128 22 12.8179 22 12C22 6.81465 18.0533 2.5511 13 2.04938V11.2928L21.7166 14.3737Z" fill="currentColor"/><Path d="M21.0501 16.2594L11 12.7072V2.04938C5.94668 2.5511 2 6.81465 2 12C2 17.5229 6.47715 22 12 22C15.9995 22 19.4506 19.6521 21.0501 16.2594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPieChart1;
